//
//
//
//

    export default {
        mounted(){
            this.logout()
        },
        methods: {
            logout () {				
				this.$http.get('logout')
				.then(response=>{
					this.$store.commit('clearLoginInfo')
					this.$router.push({path: '../login'})	
				}).catch(response=>{
					this.$Message.error(response.body.message)
				})			
			}
        }
    }



// WEBPACK FOOTER //
// ./src/views/logout.vue